import { createFileRoute } from "@tanstack/react-router";
import { PersonaPage } from "@/components/admin/ai-assistant/persona-page";
import { requireAdminFeature } from "@/middleware/admin-feature-guard";

export const Route = createFileRoute("/admin/ai-assistant/persona")({
	beforeLoad: requireAdminFeature("admin-ai-persona"),
	component: PersonaPage,
});
